import React from 'react';
import { Box, Typography } from '@mui/material';
// 660px WebP rather than the 1000x1000 PNG master: this is a card image, and
// the master cost 1 MB. P25009-378 BR-3.
import tire from '../../../assets/dack-660.webp';
import "./ListingItem.css";

const ListingItem = ({ image, title, location, price, brand }) => {
  return (
    <Box className="listing-item">
      <img src={tire} alt="Image of listing" style={{ alignSelf: "center", objectFit: "contain", width: "80%" }}></img>
      <Box sx={{ backgroundColor: "var(--wheelplaceWhite)", paddingLeft: "24px" }}>
        <Typography className="listing-item-text-bold">{title}</Typography>
        <Typography className="listing-item-text">{location}</Typography>
        <Typography className="listing-item-text-bold">{price}</Typography>
      </Box>
      <Box sx={{ backgroundColor: "var(--wheelplaceWhite)" }}>
        <Typography
          sx={{ backgroundColor: "var(--wheelplaceTextColor)",
            width: "50%",
            textAlign: "center",
            color: "white",
          }}
          className="listing-item-text-bold"
        >
          {brand}
        </Typography>
      </Box>
    </Box>
  );
};

export default ListingItem;
